/* 🤖 this file was generated by svg-to-ts */
export const matIconTurnedInNot: {
  name: 'turned-in-not';
  data: string;
} = {
  name: 'turned-in-not',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15-5-2.18L7 18V5h10v13z"/></svg>`
};
